module.exports = __webpack_public_path__ + "img/info.64ce0ccf.svg";